import { render } from "./UpcomingEventsWeekSlider.vue?vue&type=template&id=13de8cb8"
import script from "./UpcomingEventsWeekSlider.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsWeekSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__